import { Map } from 'immutable'
import _ from 'lodash'

import { OPEN_DIALOG, CLOSE_DIALOG, DIALOG_SET_LOADING } from './constants'

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case OPEN_DIALOG: {
            const type = _.get(action, 'data.type', null)
            const id = _.get(action, 'data.id', null)

            const uniqueId = `${type}${id ? `_${id}` : ''}`
            const isInList = !!state?.[uniqueId]

            if (isInList) return state

            const settings = _.get(action, 'data.settings', null)

            return state.set(uniqueId, Map({ uniqueId, type, id, settings, loading: false }))
        }
        case CLOSE_DIALOG: {
            const type = _.get(action, 'data.type', null)
            const id = _.get(action, 'data.id', null)

            const uniqueId = `${type}${id ? `_${id}` : ''}`

            return state.remove(uniqueId)
        }
        case DIALOG_SET_LOADING: {
            const type = action?.data?.type
            const id = action?.data?.id
            const value = action?.data?.value

            if (!type || !id) return state

            const uniqueId = `${type}${id ? `_${id}` : ''}`

            return state.setIn([uniqueId, 'loading'], value)
        }
        default:
            return state
    }
}
